import {
  CompanyFactKey,
  CompanyFactSchemaVersion,
  ConflictStrategy,
  type FactKeyConfig,
} from '../core'

export const CONTACTS_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  // ── Internal Contacts ──
  [CompanyFactKey.INTERNAL_CONTACTS_COPS]: {
    schemaVersion: CompanyFactSchemaVersion.CONTACT_V1,
    displayName: 'COps Contact',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
  [CompanyFactKey.INTERNAL_CONTACTS_WOPS]: {
    schemaVersion: CompanyFactSchemaVersion.CONTACT_V1,
    displayName: 'WOps Contact',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },

  // ── External Contacts ──
  [CompanyFactKey.EXTERNAL_CONTACTS]: {
    schemaVersion: CompanyFactSchemaVersion.CONTACT_V1,
    displayName: 'External Contacts',
    conflictStrategy: ConflictStrategy.ALLOW_MULTIPLE,
  },
}
